// import config from 'config';
import axios from 'axios';
import { handleResponse } from './http-utils';

export const configService = {
    getAll,
    getById,
    get,
    add,
    update,
    deleteEntity
};

function getAll() {
    return axios.get(`/config/all`).then(handleResponse);
}

function getById(id) {
    return axios.get(`/config/${id}`).then(handleResponse);
}

function get() {
    return axios.get(`/config`).then(handleResponse);
}

function add(config, logoFile, darkLogoFile, miniLogoFile, emailLogoFile, favicon16File, favicon32File ) {
    let formData = new FormData();
    formData.append("logoFile", logoFile);
    formData.append("darkLogoFile", darkLogoFile);
    formData.append("miniLogoFile", miniLogoFile);
    formData.append("emailLogoFile", emailLogoFile);
    formData.append("favicon16File", favicon16File);
    formData.append("favicon32File", favicon32File);
    formData.append("configData", JSON.stringify(config));

    return axios.post(`/config`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(handleResponse);
}

function update(config, logoFile, darkLogoFile, miniLogoFile, emailLogoFile, favicon16File, favicon32File) {
    let formData = new FormData();
    formData.append("logoFile", logoFile);
    formData.append("darkLogoFile", darkLogoFile);
    formData.append("miniLogoFile", miniLogoFile);
    formData.append("emailLogoFile", emailLogoFile);
    formData.append("favicon16File", favicon16File);
    formData.append("favicon32File", favicon32File);
    formData.append("configData", JSON.stringify(config));

    return axios.put(`/config/${config.domainConfigId}`,
        formData,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then(handleResponse);
}

function deleteEntity(config) {
    return axios.delete(`/config/${config.domainConfigId}`).then(handleResponse);
}
